import { render, staticRenderFns } from "./VerifyEmailPage.vue?vue&type=template&id=4e5c43bf&scoped=true"
import script from "./VerifyEmailPage.vue?vue&type=script&lang=ts"
export * from "./VerifyEmailPage.vue?vue&type=script&lang=ts"
import style0 from "./VerifyEmailPage.vue?vue&type=style&index=0&id=4e5c43bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c43bf",
  null
  
)

export default component.exports